import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

class Underwriter extends Component {

    constructor(props) {
        super(props);
        this.underWriterText = this.getUnderWriterText(props.stateProps);
    }

    /**
     * Component shouldn't update after mount
     * @returns {Boolean} returns false to prevent the component from re-rendering
     */
    shouldComponentUpdate = () => false;

    /**
     * Gets Underwriter text
     * @returns {Node} Underwriter text from stateProps
     */
    getUnderWriterText = ({ product }) => {
        const underwriter = product.getIn(['productMeta', 'underwriter']);
        if (underwriter) {
            const { name, acn, afsl } = underwriter.toJS();
            if (name && acn && afsl) {
                return (
                    <span>
                        {`Underwriter: ${name}, ACN ${acn}, AFS Licence No: ${afsl}`}
                    </span>
                );
            }

            if (name) {
                return (
                    <span>
                        {`Underwriter: ${name}`}
                    </span>
                );
            }
        }
        return null;
    };

    render = () => this.underWriterText;

}

Underwriter.propTypes = {
    stateProps: PropTypes.shape({
        product: PropTypes.shape({
            productMeta: PropTypes.shape({
                underwriter: PropTypes.shape({
                    name: PropTypes.string,
                    acn: PropTypes.string,
                    afsl: PropTypes.string
                })
            })
        })
    })
};

Underwriter.defaultProps = {
    stateProps: {
        product: Map()
    }
};

export { Underwriter };
